import React, { useEffect, useState } from "react";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { doService } from "../../../services/ServiceHelper";
import { getUserLists } from "../../../services/UserService";

function StudentListSelector({
  school,
  jwt,
  onChange,
  showSelectListOption = false,
  showAllListOption = true,
  showAllStudentsOption = false,
  labelText = "Student List *"
}) {
  const [_studentLists, setStudentLists] = useState([]);
  const [_selectListEid, setSelectedListEid] = React.useState("XX");

  useEffect(() => {
    initLists();
  }, []);

  const initLists = () => {
    doService(getUserLists(school, jwt), (result) => {
      setStudentLists(result.data);
    });
  };

  const handleChangeList = (event) => {
    setSelectedListEid(event.target.value);

    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <>
      <InputLabel>{labelText}</InputLabel>
      <Select
        fullWidth
        size="small"
        onChange={handleChangeList}
        value={_selectListEid}
      >
        {showAllListOption === true && (
          <MenuItem key="XX" value="XX">
            -- ALL LISTS --
          </MenuItem>
        )}

      {showAllStudentsOption === true && (
          <MenuItem key="XX" value="XX">
            -- ALL STUDENTS --
          </MenuItem>
        )}

        {showSelectListOption === true && (
          <MenuItem key="XX" value="XX">
            -- SELECT A LIST --
          </MenuItem>
        )}
        {_studentLists.map((list) => (
          <MenuItem key={list.eid} value={list.eid}>
            {list.name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
}

export default StudentListSelector;
